import { FC } from 'react';
import { Card } from 'primereact/card';
import { useAuth0 } from '@auth0/auth0-react';
import '../../themes/glass/glass-light/theme-base.scss'; //theme

export const AutoClassLinkLogin: FC = () => {
  const { loginWithRedirect } = useAuth0();

  sessionStorage.setItem('track_login_action', 'true');
  loginWithRedirect({
    authorizationParams: {
      connection: 'ClassLink',
    },
  });

  return (
    <div className="nc_page-inner">
      <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
        <Card
          className="flex justify-content-start tw-text-center"
          title={
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
              <img src={'/circle.png'} alt="circle" width={50} height={50} />
              <span>
                Welcome to <br />
                <em>Teach to One Roadmaps </em> !
              </span>
            </div>
          }
        >
          <div className="flex flex-column gap-lg align-items-center w-full">
            <p>Please wait while we log you in with ClassLink</p>
            <div className="flex w-full justify-content-center">
              <a href="https://teachtoone.org/terms-of-use/" target="_blank" rel="noreferrer">
                Terms & Rules
              </a>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
